<form >
  <!-- Modal Header -->
  <div class="modal-header" [ngClass]="{
    'modal-header--pro': isProUser,
    'modal-header--essentiel': isEssentielUser,
    'modal-header--premium': isPremiumUser && !isPremiumGiftedUser && !isPremiumDiscoveryUser
  }">
    <h4 class="modal-title bff-text bff-text--large">{{ 'param.modal.version.title' | translate }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>

  <!-- Modal Body -->
  <div class="modal-body" [class]="showPaypal ? 'modal-body--paypal' : 'modal-body--wide'">
    <!-- Available actions -->
    <div class="bff-form-row"><div class="bff-form-group">
        <!-- Billing Period Toggle (hidden when PayPal is shown) -->
        <div class="pricing-billing-toggle" *ngIf="!showPaypal" [class.disabled]="isBlocked">
          <div class="billing-toggle-wrapper">
            <span class="billing-toggle-label">Mode de paiement </span>
            <div class="billing-toggle-switch">
              <button 
                type="button"
                class="billing-toggle-btn" 
                [class.active]="!isAnnualBilling"
                [disabled]="isBlocked"
                (click)="setBillingPeriod('monthly')">
                <span class="billing-toggle-text">Mensuel </span>
              </button>
              <button 
                type="button"
                class="billing-toggle-btn" 
                [class.active]="isAnnualBilling"
                [disabled]="isBlocked"
                (click)="setBillingPeriod('annual')">
                <span class="billing-toggle-text">Annuel (-22%)</span>
              </button>
            </div>
          </div>
        </div>
        
        <!-- All users see all available versions (hidden when PayPal is shown) -->
        <div class="pricing-cards-container" *ngIf="!showPaypal">
          <!-- Standard Card -->
          <div class="pricing-card pricing-card-standard" [class.current-version]="isStandardUser">
            <div class="pricing-card-current" *ngIf="isStandardUser">
              <i class="fas fa-check"></i>
              <span>Version actuelle</span>
            </div>
            <div class="pricing-card-label">
              <div class="pricing-card-header">
                <h3 class="pricing-card-title bff-text bff-text--bold">{{ 'signup.version.standard' | translate }}</h3>
                <div class="pricing-card-price bff-text bff-text--bold">100 % Gratuit</div>
                <div class="pricing-card-subtitle bff-text bff-text--small">Sans engagement</div>
              </div>
              <ul class="pricing-card-features">
                <li class="bff-text">{{ 'signup.version.standard.essential-func' | translate }}</li>
                <li class="bff-text">{{ 'signup.version.standard.free' | translate }}</li>
              </ul>
              <div class="pricing-card-footer">
                <div class="bff-text bff-text--muted bff-text--center" *ngIf="isStandardUser" style="padding: 0.25rem; font-size: 0.7rem;">
                  <button type="button" class="bff-button bff-button--secondary bff-button--small" style="margin-top: 0.25rem;">
                  Version en cours
                  </button>
                </div>
                <button 
                  type="button" 
                  class="bff-button bff-button--secondary bff-button--full-width"
                  *ngIf="!isStandardUser"
                  [disabled]="isBlocked"
                  (click)="downgradeToStandard()">
                  Choisir BASIC
                </button>
              </div>
            </div>
          </div>
          
          <!-- Essentiel Card -->
          <div class="pricing-card pricing-card-essentiel" [class.current-version]="isEssentielUser">
            <div class="pricing-card-current" *ngIf="isEssentielUser">
              <i class="fas fa-check"></i>
              <span>Version actuelle</span>
            </div>
            <div class="pricing-card-label">
              <div class="pricing-card-header">
                <h3 class="pricing-card-title bff-text bff-text--bold">{{ 'signup.version.essentiel' | translate }}</h3>
                <div class="pricing-card-price bff-text">
                  <span class="price-amount bff-text bff-text--bold" style="color: #30a8dc ;">{{ essentielPrice }}€</span>
                  <span class="price-period bff-text bff-text--small" style="color: #30a8dc ;">/{{ isAnnualBilling ? 'an' : 'mois' }}</span>
                </div>
                <div class="pricing-card-subtitle bff-text bff-text--small" *ngIf="isAnnualBilling">
                  <div class="monthly-equivalent">soit 2,33€/mois</div>
                  <b>-18% </b>pour paiement annuel
                </div>
              </div>
              <ul class="pricing-card-features">
                <li class="bff-text">{{ 'signup.version.essentiel.desc' | translate }}</li>
                <li class="bff-text">{{ 'signup.version.essentiel.desc3' | translate }}</li>
                <li class="bff-text">{{ 'signup.version.essentiel.desc2' | translate }}</li>
                <li class="bff-text">{{ 'signup.version.essentiel.opsPerMonth' | translate }}</li>
              </ul>
              <div class="pricing-card-footer">
                <button type="button" class="bff-button bff-button--primary bff-button--full-width" [disabled]="isBlocked" (click)="subscribeToEssentiel()" *ngIf="!isEssentielUser">
                  Souscrire
                </button>
                <div class="bff-text bff-text--muted bff-text--center" *ngIf="isEssentielUser" style="padding: 0.25rem; font-size: 0.7rem;">
                  <button type="button" class="bff-button bff-button--secondary bff-button--small" [disabled]="isBlocked" (click)="hasAnnualSubscription ? switchToMonthlyEssentiel() : switchToAnnualEssentiel()" style="margin-top: 0.25rem;">
                    {{ hasAnnualSubscription ? 'Revenir en version mensuelle' : 'Passer en annuel' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Premium Card -->
          <div class="pricing-card pricing-card-featured pricing-card-premium" [class.current-version]="isPremiumUser && !isPremiumGiftedUser && !isPremiumDiscoveryUser">
            <div class="pricing-card-badge" *ngIf="!(isPremiumUser && !isPremiumGiftedUser && !isPremiumDiscoveryUser)">
              <i class="fas fa-star"></i>
              <span>Populaire</span>
            </div>
            <div class="pricing-card-current" *ngIf="isPremiumUser && !isPremiumGiftedUser && !isPremiumDiscoveryUser">
              <i class="fas fa-check"></i>
              <span>Version actuelle</span>
            </div>
            <div class="pricing-card-label">
              <div class="pricing-card-header">
                <h3 class="pricing-card-title bff-text bff-text--bold">{{ 'signup.version.premium' | translate }}</h3>
                <div class="pricing-card-price bff-text">
                  <span class="price-amount bff-text bff-text--bold" style="color: #30a8dc ;">{{ premiumPrice }}€</span>
                  <span class="price-period bff-text bff-text--small" style="color: #30a8dc ;">/{{ isAnnualBilling ? 'an' : 'mois' }}</span>
                </div>
                <div class="pricing-card-subtitle bff-text bff-text--small" *ngIf="isAnnualBilling">
                  <div class="monthly-equivalent">soit 3,99€/mois</div>
                  <b>-17% </b>pour paiement annuel
                </div>
              </div>
              <ul class="pricing-card-features">
                <li class="bff-text">{{ 'signup.version.premium.desc' | translate }}</li>
                <li class="bff-text">{{ 'signup.version.premium.desc3' | translate }}</li>
                <li class="bff-text">{{ 'signup.version.premium.desc2' | translate }}</li>
                <li class="bff-text">{{ 'signup.version.premium.opsPerMonth' | translate }}</li>
              </ul>
              <div class="pricing-card-footer">
                <button type="button" class="bff-button bff-button--primary bff-button--full-width" [disabled]="isBlocked" (click)="subscribeToPremium()" *ngIf="!(isPremiumUser && !isPremiumGiftedUser && !isPremiumDiscoveryUser)">
                  Souscrire
                </button>
                <div class="bff-text bff-text--muted bff-text--center" *ngIf="isPremiumUser && !isPremiumGiftedUser && !isPremiumDiscoveryUser" style="padding: 0.25rem; font-size: 0.7rem;">
                  <button type="button" class="bff-button bff-button--secondary bff-button--small" [disabled]="isBlocked" (click)="hasAnnualSubscription ? switchToMonthlyPremium() : switchToAnnualPremium()" style="margin-top: 0.25rem;">
                    {{ hasAnnualSubscription ? 'Revenir en version mensuelle' : 'Passer en annuel' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Pro Card -->
          <div class="pricing-card pricing-card-pro" [class.current-version]="isProUser">
            <div class="pricing-card-current" *ngIf="isProUser">
              <i class="fas fa-check"></i>
              <span>Version actuelle</span>
            </div>
            <div class="pricing-card-label">
              <div class="pricing-card-header">
                <h3 class="pricing-card-title bff-text bff-text--bold">{{ 'signup.version.pro' | translate }}</h3>
                <div class="pricing-card-price bff-text">
                  <span class="price-amount bff-text bff-text--bold" style="color: #30a8dc ;">{{ proPrice }}€</span>
                  <span class="price-period bff-text bff-text--small" style="color: #30a8dc ;">/{{ isAnnualBilling ? 'an' : 'mois' }}</span>
                </div>
                <div class="pricing-card-subtitle bff-text bff-text--small" *ngIf="isAnnualBilling">
                  <div class="monthly-equivalent">soit 6,49€/mois</div>
                  <b>-17%</b> pour paiement annuel
                </div>
              </div>
              <ul class="pricing-card-features">
                <li class="bff-text">{{ 'signup.version.pro.desc' | translate }}</li>
                <li class="bff-text">{{ 'signup.version.pro.desc2' | translate }}</li>
                <li class="bff-text">{{'signup.version.pro.desc4' | translate}}</li>
                <li class="bff-text">{{ 'signup.version.pro.desc3' | translate }}</li>
                <li class="bff-text">{{ 'signup.version.pro.opsPerMonth' | translate }}</li>
              </ul>
              <div class="pricing-card-footer">
                <button type="button" class="bff-button bff-button--primary bff-button--full-width" [disabled]="isBlocked" (click)="subscribeToPro()" *ngIf="!isProUser">
                  Souscrire
                </button>
                <div class="bff-text bff-text--muted bff-text--center" *ngIf="isProUser" style="padding: 0.25rem; font-size: 0.7rem;">
                  <button type="button" class="bff-button bff-button--secondary bff-button--small" [disabled]="isBlocked" (click)="hasAnnualSubscription ? switchToMonthlyPro() : switchToAnnualPro()" style="margin-top: 0.25rem;">
                    {{ hasAnnualSubscription ? 'Revenir en version mensuelle' : 'Passer en annuel' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Cancel Subscription Section (for all paid users) -->
        <div *ngIf="!showPaypal && !isStandardUser" class="cancel-subscription-section">
          <hr class="cancel-divider">
          <div class="cancel-content">
            <h5 class="cancel-title">Annuler votre abonnement ?</h5>
            <p class="cancel-description">
              Vos abonnements sont sans engagement et vous pouvez à tout instant revenir à la version BASIC, gratuite. Pas d'inquiétude, toutes vos données sont conservées mais vous constaterez des limites dans l'utilisation de votre application.
            </p>
            <button type="button" class="bff-button bff-button--danger bff-button--with-left-icon" [disabled]="isBlocked" (click)="downgradeToStandard()">
              <i class="fas fa-times-circle"></i>
              <span>Annuler l'abonnement et revenir en version BASIC</span>
            </button>
          </div>
        </div>
        
      </div>
    </div>
    
    <!-- Info box -->
    <!-- <div class="bff-form-row">
      <div class="bff-form-group">
        <div class="bff-alert bff-alert--info">
          <i class="fa fa-info-circle"></i>
          <div class="bff-alert__content">
            <span class="bff-text" [innerHTML]="'param.modal.version.user.compare' | translate"></span>
          </div>
        </div>
      </div>
    </div> -->
  </div>

  <!-- PayPal Modal Section -->
  <div *ngIf="showPaypal" class="paypal-section">
    <div class="paypal-content">
      <!-- Essentiel -->
      <app-paypal-essentiel
        *ngIf="selectedVersion === 'ESSENTIEL'"
        [idUser]="User?.idUser || 0"
        [paymentMode]="checkRythmeAbonnement === 'ESSENTIEL_ANNUEL' ? 'ESSENTIEL_ANNUEL' : 'ESSENTIEL_MENSUEL'">
      </app-paypal-essentiel>
      <!-- Premium -->
      <app-paypal-premium
        *ngIf="selectedVersion === 'PREMIUM'"
        [idUser]="User?.idUser || 0"
        [paymentMode]="checkRythmeAbonnement === 'PREMIUM_ANNUEL' ? 'PREMIUM_ANNUEL' : 'PREMIUM_MENSUEL'">
      </app-paypal-premium>
      <!-- Pro -->
      <app-paypal-pro
        *ngIf="selectedVersion === 'PRO'"
        [idUser]="User?.idUser || 0"
        [paymentMode]="checkRythmeAbonnement === 'PRO_ANNUEL' ? 'PRO_ANNUEL' : 'PRO_MENSUEL'">
      </app-paypal-pro>
    </div>
    
    <!-- Back button -->
    <div class="paypal-footer">
      <button type="button" class="bff-button bff-button--secondary bff-button--with-left-icon" (click)="showPaypal = false">
        <i class="fas fa-arrow-left"></i>
        <span>Retour au choix de version</span>
      </button>
    </div>
  </div>


</form>